import React, { Component } from 'react';
import './column.scss';
import AddActivity from './add-activity';
import AddButton from './add-button';
import ColumnHeader from './column-header';
import AIDescForm from './ai-form';
import FreeTextForm from '../column/freetext-form';
import { Droppable } from "react-beautiful-dnd";
import { BoardColumnState } from "../../types/boardColumn.types";
import CardList from './card-list';
import BoardConst from '../../utils/constants/board';
import BoardService from '../../services/board.service';
import AddColumnWsModal from '../../modals/add-column-ws';
import AddColumnUserModal from '../../modals/add-column-user';
import { WbUniqueIdMixin } from '../../../utils/common';

class BoardColumnComp extends Component<any, BoardColumnState> {
  boardService = new BoardService();
  constructor(props: any) {
    super(props);
    this.state = {
      addNew: false,
      popupData: {},
    }
    this.hideAIForm = this.hideAIForm.bind(this);
  }

  generateSecureRandomId = () => {
    var buf = new Uint8Array(1);
    window.crypto.getRandomValues(buf);
    return buf[0];
  }

  onClosePopup = () => {
      this.setState({
        addNew: false,
        popupData: {}
      })
  }

  toggleAddActivity = (aiType: number) => {
    this.setState((prevState) => ({ ...prevState, aiType }));
    this.toggleAddItem();
  }

  toggleAddItem = async() => {
    const {boardDetails} = this.props.board;
    let cardType = BoardConst.BOARD_DATATYPE_ACTIONS;
    if (boardDetails.board) {
        cardType = boardDetails.board.type;
    }
    let popupData = {};
    if (cardType == BoardConst.BOARD_DATATYPE_WORKSTREAMS) {
      showLoaderWidget(document.getElementById('content'));
      const response = await this.boardService.getWorkstreamData();
      popupData = response.data || [];
      removeLoader();
    }
    else if (cardType == BoardConst.BOARD_DATATYPE_PEOPLE) {
      showLoaderWidget(document.getElementById('content'));
      const response = await this.boardService.getUserTeamData();
      popupData = response.data || [];
      removeLoader();
    }

    this.setState((prevState) => ({
      ...prevState,
      addNew: !prevState.addNew,
      popupData
    }));
  }

  //Below code needed when we want to drag and drop column
  // handleMouseOver =(e:any)=>{
  //   let ele = e.target;
  //   if($(ele).children().hasClass('wb-card-body')){
  //     // $(ele).parent().css({'transform': 'translate(0px,62px)'});
  //     let indx = $(ele).parent().find('.ai-card-title').data('index-count');
  //     if(typeof indx != 'undefined'){
  //       window.cardIndPosition = indx;
  //     }
  //   }
  //   window.hoverElementId = this.props.columnItem.id;
  // }

  hideAIForm = () => {
    this.setState({
      addNew: false
    });
  }

  getListStyle: any = (isDraggingOver: boolean) => ({
    height: "100%",
    width: 290,
    minWidth: 290
  });

  render() {
    const { columnItem, actions, board, isDragging } = this.props;
    const { boardDetails, boardFilters={}, boardView, fusDetail } = board;
    const columnDataLength = columnItem.data.length;
    const {highlighted_my_items, showIssueTypeIcon, highlightIssuesByType} = boardFilters;
    let cardType = BoardConst.BOARD_DATATYPE_ACTIONS;
    if (boardDetails.board) {
      cardType = boardDetails.board.type;
    }
    const {is_co_manager, is_manager, is_team_admin } = boardDetails.wsPermissions || {};
    const {editBoard} = boardDetails.userPermission || {};

    const { aiType } = this.state;
    const isNewCol: boolean = columnItem.id.indexOf("new_col_") !== -1;
    const isAdminPermission: boolean = ((is_co_manager || is_manager || is_team_admin) || editBoard == '1');
    const isOpenWs = (this.state.addNew && cardType == BoardConst.BOARD_DATATYPE_WORKSTREAMS);
    const isOpenUser = (this.state.addNew && cardType == BoardConst.BOARD_DATATYPE_PEOPLE);
    const isShowAddButton: boolean = (!isNewCol &&
      (boardView == BoardConst.BOARD_VIEW_ACTIVITY ||
        (boardView == BoardConst.BOARD_VIEW_SHARED &&
          isAdminPermission)));

    let columnStyle: any = {};
    if(isDragging){
      columnStyle.height = "450px";
      columnStyle.overflow = "hidden";
    }else{
      columnStyle.height = "100%";
      columnStyle.overflow = "unset";
    }
    // let colClass = ' board-column-type-' + boardType + ' board-column-header-' + columnId;
    //console.log('boardDetailsboardDetails', boardDetails);
    return (
      <div className="boardColumnWrapper" style={columnStyle}>
        <ColumnHeader
          column={columnItem}
          boardType={boardDetails.boardType}
          count={columnDataLength}
          wsPermission={boardDetails.wsPermissions}
          userPermission={boardDetails.userPermission}
          isDragging={isDragging}
          cardType={cardType}
          boardDetails={boardDetails}
          dragHandleProps ={this.props.dragHandleProps}
          />
        {isShowAddButton
          && (
            cardType == BoardConst.BOARD_DATATYPE_ACTIONS
              ? (
                <AddActivity
                  onAdd={this.toggleAddActivity}
                  workstreamId={boardDetails.tagId}
                  columnId={columnItem.id}
                />
              )
              : <AddButton onClick={this.toggleAddItem} />
          )}
        {
          this.state.addNew && cardType == BoardConst.BOARD_DATATYPE_ACTIONS &&
          <AIDescForm
            aiType={aiType}
            columnId={columnItem.id}
            hideAIForm={this.hideAIForm}
          />
        }
        {
          this.state.addNew && boardView == BoardConst.BOARD_VIEW_SHARED &&
          cardType == BoardConst.BOARD_DATATYPE_FREETEXT &&
          <FreeTextForm
            key={`text-card-${this.generateSecureRandomId()}`}
            columnId={columnItem.id}
            {...board}
            hideAIForm={this.hideAIForm}
          />
        }

        {/* <NewFreeTextBoxComp
                boardType={boardType}
                columnId={columnId}
                actions={actions}
                s3Data={boardDetails.s3Data}
                upload_max_size={boardDetails.upload_max_size}
                upload_max_size_configured={boardDetails.upload_max_size_configured}
              /> */}
        {/* <AIDescForm /> */}
        {/* <div className="boardColumnWrapper__main"> */}
          <Droppable droppableId={columnItem.id} >
            {
              (provided: any, snapshot: any) => (
                <div ref={provided.innerRef} {...provided.droppableProps} style={this.getListStyle(snapshot.isDraggingOver)} >
                    {
                      <CardList
                        data ={columnItem.data}
                        columnId={columnItem.id}
                        viewAiPane={boardDetails.viewAiPane}
                        memberHighlightedId={boardDetails.memberHighlightedId}
                        highlightedAI={(highlighted_my_items == '1')}
                        showIssueTypeIcon={(showIssueTypeIcon == '1')}
                        highlightIssuesByType={highlightIssuesByType == '1'}
                        user={boardDetails.user}
                        boardType={boardDetails.boardType}
                        boardView={boardView}
                        cardType={cardType}
                        userPermission={boardDetails.userPermission}
                        boardDetails={boardDetails}
                        fusDetail={fusDetail}
                      />
                    }
                  {provided.placeholder}

                </div>
              )
            }
          </Droppable>
        {/* </div> */}
        { isOpenWs && <AddColumnWsModal
          onClose={this.onClosePopup}
          data={this.state.popupData}
          columnId={columnItem.id}
        />}
        { isOpenUser && <AddColumnUserModal
          onClose={this.onClosePopup}
          data={this.state.popupData}
          columnId={columnItem.id}
        />}
      </div>
    );
  }
}

export default BoardColumnComp;
